import React, {useEffect, useMemo, useState} from 'react';
import {Box, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles} from '@material-ui/core';
import {IconClose} from '../../../components/Icons';
import {rieltor} from '../../../styles/theme';
import Typo from '../../../components/Typo';
import {FormattedMessage} from 'react-intl';
import {ButtonPurple} from '../../../components/Buttons';
import RouterLink from '../../common/RouterLink';
import {AlertViewSettingKey, LocalStorageKeys, RoleId} from '../../../common/types';
import {useCurrentUser} from '../../../hooks/user';
import {createProfileEditUrl, createProfileSummaryUrl} from '../../../utils/navigation';
import {useLocalStorage} from '@rehooks/local-storage';
import {isSameHour} from 'date-fns';
import {UsersAPI} from '../../../services/UsersAPI';
import {fetchUserInfo} from '../../../store/user/actions';
import {useDispatch, useSelector} from 'react-redux';
import {localStoreSelector} from '../../../store/local/selectors';
import {setLocalItem} from '../../../store/local/reducer';
import {IsAlertVisible} from '../../../utils';

const ALERT_ID_FORCE_IPN = '400';
const useStyles = makeStyles((theme) => ({
  popupWrapper: {
    '& .MuiDialog-paper': {
      maxWidth: '650px !important',
    },
    '& .MuiDialogContent-root': {
      padding: '8px 30px',
    },
  },
}));
const ForceIpnAlert = () => {
  const classes = useStyles();
  const usersAPI = useMemo(() => new UsersAPI(), []);
  const dispatch = useDispatch();

  const user = useCurrentUser();
  const [open, setOpen] = useState(false);

  const isAlertVisible = IsAlertVisible(user, ALERT_ID_FORCE_IPN, null);

  useEffect(() => {
    if (!isAlertVisible) {
      return;
    }
    if (user && !user.inn && !user.noIpn && user.verificated && (user.roleId === RoleId.Realtor)) {
      setOpen(true);
      try {
        usersAPI.updateAlertStatus({id: ALERT_ID_FORCE_IPN, firstView: true});
        dispatch(fetchUserInfo());
        dispatch(setLocalItem(LocalStorageKeys.ForceIpnAlert, true));
      } catch (e) {
      }
    }
  }, [isAlertVisible]);

  if (user === null) {
    return null;
  }

  return (
      <Dialog
          className={classes.popupWrapper}
          open={open}
      >
        <DialogTitle style={{padding: '8px 16px'}}>
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <div>&nbsp;</div>
          </Box>
        </DialogTitle>

        <DialogContent>
          <div>
            <Typo variant={'title0'}>
              <FormattedMessage id={'alerts.force_ipn_alert.title'}/>
            </Typo>
          </div>

          <p style={{margin: '30px 0 0 0', lineHeight: '28px', fontFamily: rieltor.fontFamily, fontSize: '16px'}}>
            <FormattedMessage id={'alerts.force_ipn_alert.text'}/>
          </p>
          <p style={{margin: '0 0 30px 0', lineHeight: '28px', fontFamily: rieltor.fontFamily, fontSize: '16px'}}>
            <FormattedMessage id={'alerts.force_ipn_alert.text_alter'}/>
          </p>
        </DialogContent>

        <DialogActions style={{justifyContent: 'center', padding: '0 16px 20px 16px'}}>
          <ButtonPurple
              // @ts-ignore
              component={RouterLink}
              to={createProfileSummaryUrl({})}
          >
            <FormattedMessage id={'alerts.force_ipn_alert.button'}/>
          </ButtonPurple>
        </DialogActions>
      </Dialog>
  );
};

export default ForceIpnAlert;
